import React from "react";
import { KpiCard, Panel, StatRow } from "@/pages/dashboard/widgets";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function ProductionView({ data }) {
  if (!data) return null;
  const t = data.today_meters || {};
  const chart = [
    { stage: "Printing", meters: t.printing ?? 0 },
    { stage: "Fusing", meters: t.fusing ?? 0 },
    { stage: "Cutting", meters: t.cutting ?? 0 },
    { stage: "Stitching", meters: t.stitching ?? 0 },
    { stage: "Bundle Pack", meters: t.packing ?? 0 },
  ];
  return (
    <div className="space-y-6" data-testid="production-view">
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <KpiCard testid="prod-kpi-waiting" label="Jobs waiting" value={data.jobs_waiting ?? 0} accent="text-amber-600" />
        <KpiCard testid="prod-kpi-active" label="In progress" value={data.jobs_in_progress ?? 0} accent="text-indigo-600" />
        <KpiCard testid="prod-kpi-util" label="Machine utilisation" value={`${data.machine_utilisation ?? 0}%`} sub={`${data.machines_running ?? 0}/${data.machines_total ?? 0} running`} accent="text-sky-600" />
        <KpiCard testid="prod-kpi-risk" label="Jobs at risk" value={data.jobs_at_risk ?? 0} accent="text-rose-600" />
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <Panel title="Today's output (meters)">
          <div className="h-56" data-testid="prod-output-chart">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chart}>
                <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" />
                <XAxis dataKey="stage" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 11 }} />
                <Tooltip />
                <Bar dataKey="meters" fill="#4f46e5" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Panel>
        <Panel title="Quality & queues">
          <StatRow items={[
            { label: "QC pending", value: data.qc_pending ?? 0, accent: "text-amber-600" },
            { label: "Rework queue", value: data.rework_queue ?? 0, accent: "text-rose-600" },
            { label: "QC pass rate", value: `${data.qc?.pass_rate ?? 0}%`, accent: "text-emerald-600" },
            { label: "QC passed", value: data.qc?.passed ?? 0 },
            { label: "QC rejected", value: data.qc?.rejected ?? 0 },
          ]} />
        </Panel>
      </div>
    </div>
  );
}
